import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { Link } from "react-router-dom";
import "react-form-wizard-component/dist/style.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getEmployeeList } from "../../EmployeeList/Service/employeeService";
import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { Dropdown } from "primereact/dropdown";
import { TostMsg } from "../../../../App";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch } from "react-redux";
import { setLeaveRequestData } from "../../../../Services/Redux/DataTransferToAnother";
import { addApplyWFH } from "../Wfh/WfhSerevice";
import WfhNavBarItems from "../Wfh/WfhCommon/WfhNavBarItems";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
const ComponentLoader = React.lazy(() =>
  import("../../../../Shared/Sidebar/ComponentLoader")
);
function WFHForOther() {
  const dispatch = useDispatch();
  const [AddMore, setAddMore] = React.useState(0);
  const [Isloading, setIsloading] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState(null);
  const [employeDetails, setEmployeeDetails] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [showHalfDay, setShowHalfDay] = useState(false);
  const toster = useContext(TostMsg);
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  const [checkedHalfDay, setCheckedHalfDay] = useState(false);
  const [dateError, setDateError] = useState(false);
  const history = useHistory();
  let halfPreferences = "";
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [howItWorksText, setHowItWorksText] = useState([]);
  const [WFHApplyForOthersText, setApplyForOthers] = useState([]);

  useEffect(() => {
    GetMasterSystemAlertList();
  }, []);

  var BasicInfo = false;
  let EmplyeeInfo = false;
  let PersonalInfo = false;

  const renderComponent = () => {
    if (AddMore == 0) {
      BasicInfo = true;
      EmplyeeInfo = false;
      PersonalInfo = false;
    } else if (AddMore == 1) {
      BasicInfo = false;
      EmplyeeInfo = true;
      PersonalInfo = false;
    } else {
      BasicInfo = false;
      EmplyeeInfo = false;
      PersonalInfo = true;
    }
  };

  //For get the employee data.
  async function fetchEmployeeIdData() {
    setIsloading(true);
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 3,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 100000,
      EmployeeId: userDetails?.EmpId,
      IsSuggestedOnly: 0,
    };

    try {
      let employeesList = await getEmployeeList(params);
      let employeeValidateList = [];
      employeeValidateList = employeesList.Data?.filter(
        (el) => el?.EmpId != userDetails?.EmpId
      );
      setEmployeeDetails(employeeValidateList);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  const setEndDate = (event) => {
    const startDate = new Date(requestWfhForm.values.startDate);
    const endDate = new Date(event);
    const normalizeDate = (date) => {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };
    const normalizedStartDate = normalizeDate(startDate);
    const normalizedEndDate = normalizeDate(endDate);
    if (normalizedStartDate <= normalizedEndDate) {
      setDateError(false);
      setCheckedHalfDay(false);
      halfPreferences = "";
    } else {
      setDateError(true);
      setCheckedHalfDay(true);
    }
  };

  const setStartDate = (event) => {
    // requestWfhForm.setFieldValue("endDate", event);
    const selectedStartDate = new Date(event);

    const currentEndDate = new Date(requestWfhForm.values.endDate);

    if (selectedStartDate >= currentEndDate) {
      requestWfhForm.setFieldValue(
        "endDate",
        selectedStartDate.toISOString().split("T")[0]
      );
      setDateError(false);
      setCheckedHalfDay(false);
      halfPreferences = "";
    }
  };

  const requestWfhValidation = Yup.object().shape({
    EmpId: Yup.string().required("Employee is required."),
    startDate: Yup.string().required("Start Date is required."),
    endDate: Yup.string().required("End Date is required."),
    reason: Yup.string().required("Reason is required."),
    isHalfDay: Yup.string(),
    halfPreference: Yup.string(),
  });

  const requestWfhForm = useFormik({
    initialValues: {
      EmpId: "",
      startDate: new Date().toISOString().split("T")[0],
      endDate: new Date().toISOString().split("T")[0],
      reason: "",
      isHalfDay: "",
      halfPreference: "",
    },
    validationSchema: requestWfhValidation,
    onSubmit: async (data) => {
      setIsloading(true);
      if (!data?.startDate || !data?.endDate) return;
      const startDate = new Date(data?.startDate);
      const endDate = new Date(data?.endDate);
      let halfPreferences = "";
      if (checkedHalfDay == false) {
        halfPreferences = "";
      } else {
        halfPreferences = data?.halfPreference ? "Second Half" : "First Half";
      }
      setIsloading(true);
      const wfgRequestParams = {
        Id: 0,
        WFHStatusId: 103,
        EmpId: data.EmpId,
        OrgId: userDetails?.OrgId,
        BranchId: userDetails?.BranchId,
        LoggedInEmpId: userDetails?.EmpId,
        Reason: data?.reason,
        StartDate: startDate,
        EndDate: endDate,
        IsHalfDay: checkedHalfDay,
        HalfPreference: halfPreferences,
      };
      if (startDate > endDate) {
        setDateError(true);
        setIsloading(false);
        return;
      }
      try {
        const applyWfhResponseWfh = await addApplyWFH(wfgRequestParams);
        if (applyWfhResponseWfh?.StatusCode === 2000) {
          const message = applyWfhResponseWfh?.Message;
          setIsloading(false);
          // GetMasterSystemAlertList("WFH_Added", 0);
          toster.current.success(message);
          requestWfhForm.resetForm();
          dispatch(setLeaveRequestData(wfgRequestParams));
          history.push(`/TeamWfh`);
        } else {
          const message = applyWfhResponseWfh?.Message;
          toster.current.warn(message);
        }
      } catch (error) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      } finally {
        setIsloading(false);
      }
    },
  });

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name === "Employee_WFH_HowItWorks") {
        setHowItWorksText(msg?.Desc);
      } else if (msg?.Name === "Employee_WFH_ApplyForOthers") {
        setApplyForOthers(msg?.Desc);
      }
    });
  }, []);

  useEffect(() => {
    const { startDate, endDate } = requestWfhForm.values;
    if (
      Number(requestWfhForm.values.WFHTypeId) === 105 ||
      Number(requestWfhForm.values.WFHTypeId) === 108 ||
      Number(requestWfhForm.values.WFHTypeId) === 106
    ) {
      setShowHalfDay(false);
      toster.current.warn("For WFH without pay you can not take half day.");
    } else if (startDate && endDate && requestWfhForm.values.reason) {
      setShowHalfDay(startDate === endDate);
    }

    if (masterSystemAlertData.length > 0) {
      toster.current.success(masterSystemAlertData);
    }
  }, [
    requestWfhForm.values.startDate,
    requestWfhForm.values.endDate,
    masterSystemAlertData,
    checkedHalfDay,
    requestWfhForm.values,
  ]);

  const employeeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage
          alt={option?.FullName}
          src={option?.ProfileImage}
          width="32"
        />
        <span>
          {option?.FullName}
          {option?.UserName?.length > 0 && ","}
        </span>
        <span>
          {option?.UserName}
          {option?.CurrentDesignation?.length > 0 && ","}
        </span>
        <span>{option?.CurrentDesignation}</span>
      </div>
    );
  };

  return (
    <div>
      {renderComponent()}
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      <div className="container-fluid position-relation">
        <div className="row">
          <div className="">
            <div className="form-head d-flex flex-wrap align-items-center mb-3">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">
                  <img src="images/new-emp.png" />
                  Apply For Others
                </h2>
                <p className="text-light">{WFHApplyForOthersText}</p>
              </div>
              {AddMore != 0 && (
                <div
                  className="rightside-tabs"
                  onClick={() => setAddMore(AddMore - 1) % 3}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="currentColor"
                    className="bi bi-arrow-left-short"
                    viewBox="0 0
 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12 8a.5.5 0 0 1-.5.5H5.7
 07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
 .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                    ></path>
                  </svg>
                </div>
              )}
              <div className="rightside-tabs">
                <WfhNavBarItems />
              </div>
            </div>
            {BasicInfo && (
              <div className="formfill-addemployee">
                <div className="row justify-content-center">
                  <div className="col-xl-8">
                    <div className="supp-req">
                      <div className="addcourseform">
                        <form onSubmit={requestWfhForm.handleSubmit}>
                          <span className="tagtitle">WFH Details</span>
                          <div className="row mt-3">
                            <div className="mb-4 col-md-12">
                              <div className="innerform-grp">
                                <label className="form-label">
                                  Team Member
                                </label>
                                <Dropdown
                                  onClick={() => fetchEmployeeIdData()}
                                  value={requestWfhForm.values.EmpId}
                                  onChange={(e) => {
                                    setSelectedEmployees(e.value);
                                    requestWfhForm.handleChange(e);
                                  }}
                                  options={employeDetails}
                                  filter={true}
                                  optionLabel="FullName"
                                  optionValue="EmpId"
                                  placeholder="Choose"
                                  maxSelectedLabels={1}
                                  itemTemplate={employeeOptionTemplate}
                                  name="EmpId"
                                  className={
                                    "w-100 md:w-20rem p-0 h-40 line-height-40 custom-multiselect" +
                                    (requestWfhForm.errors.EmpId &&
                                    requestWfhForm.touched.EmpId
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </div>
                              <div className="invalid-feedback">
                                {requestWfhForm.errors.EmpId &&
                                requestWfhForm.touched.EmpId
                                  ? requestWfhForm.errors.EmpId
                                  : null}
                              </div>
                            </div>
                            {requestWfhForm.values.EmpId && (
                              <div className="mb-4 col-md-12">
                                <div className="innerform-grp">
                                  <label className="form-label">
                                    Why you want to apply ?
                                  </label>
                                  <div className="cover-form">
                                    <input
                                      type="text"
                                      name="reason"
                                      className={
                                        "form-control" +
                                        (requestWfhForm.errors.reason &&
                                        requestWfhForm.touched.reason
                                          ? " is-invalid"
                                          : "")
                                      }
                                      maxLength={500}
                                      onChange={requestWfhForm.handleChange}
                                      value={requestWfhForm.values.reason}
                                    />
                                  </div>
                                  <div
                                    style={{
                                      textAlign: "right",
                                      fontSize: "12px",
                                      color:
                                        requestWfhForm.values.reason.length ===
                                        500
                                          ? "red"
                                          : "#555",
                                    }}
                                  >
                                    {requestWfhForm.values.reason.length}/{500}
                                  </div>
                                  <div className="invalid-feedback">
                                    {requestWfhForm.errors.reason &&
                                    requestWfhForm.touched.reason
                                      ? requestWfhForm.errors.reason
                                      : null}
                                  </div>
                                </div>
                              </div>
                            )}
                            {requestWfhForm.values.reason && (
                              <div className="mb-4 col-md-6">
                                <div className="innerform-grp">
                                  <label className="form-label">
                                    Start Date
                                  </label>
                                  <div className="cover-form w-100 d-block">
                                    <input
                                      type="date"
                                      name="startDate"
                                      onClick={(e) =>
                                        e.target.showPicker &&
                                        e.target.showPicker()
                                      }
                                      min={
                                        new Date(
                                          Date.now() - 7 * 24 * 60 * 60 * 1000
                                        )
                                          .toISOString()
                                          .split("T")[0]
                                      }
                                      className={
                                        "form-control" +
                                        (requestWfhForm.errors.startDate &&
                                        requestWfhForm.touched.startDate
                                          ? " is-invalid"
                                          : "")
                                      }
                                      onChange={(event) => {
                                        setStartDate(event.target.value);
                                        requestWfhForm.handleChange(event);
                                      }}
                                      value={
                                        requestWfhForm.values.startDate ||
                                        new Date().toISOString().split("T")[0]
                                      }
                                      placeholder="Start Date"
                                    />
                                  </div>
                                  <div className="invalid-feedback">
                                    {requestWfhForm.errors.startDate &&
                                    requestWfhForm.touched.startDate
                                      ? requestWfhForm.errors.startDate
                                      : null}
                                  </div>
                                </div>
                              </div>
                            )}
                            {requestWfhForm.values.reason && (
                              <div className="col-md-6">
                                <div className="innerform-grp">
                                  <label className="form-label">End Date</label>
                                  <div className="cover-form w-100 d-block">
                                    <input
                                      type="date"
                                      name="endDate"
                                      onClick={(e) =>
                                        e.target.showPicker &&
                                        e.target.showPicker()
                                      }
                                      min={
                                        new Date(
                                          Date.now() - 7 * 24 * 60 * 60 * 1000
                                        )
                                          .toISOString()
                                          .split("T")[0]
                                      }
                                      className={
                                        "form-control" +
                                        (requestWfhForm.errors.endDate &&
                                        requestWfhForm.touched.endDate
                                          ? " is-invalid"
                                          : "")
                                      }
                                      onChange={(event) => {
                                        setEndDate(event.target.value);
                                        requestWfhForm.handleChange(event);
                                      }}
                                      value={
                                        requestWfhForm.values.endDate ||
                                        new Date().toISOString().split("T")[0]
                                      }
                                      placeholder="Start Date"
                                    />
                                  </div>
                                  <div className="invalid-feedback">
                                    {requestWfhForm.errors.endDate &&
                                    requestWfhForm.touched.endDate
                                      ? requestWfhForm.errors.endDate
                                      : null}
                                  </div>
                                </div>
                              </div>
                            )}

                            {dateError ? (
                              <span className="invalid-feedback">
                                {" "}
                                * EndDate should be greater than or equal to Start Date.
                              </span>
                            ) : (
                              ""
                            )}

                            {showHalfDay && (
                              <div className="d-flex mb-4">
                                <div className="form-check custom-checkbox checkbox-success">
                                  <input
                                    type="checkbox"
                                    name="isHalfDay"
                                    className={
                                      "form-check-input" +
                                      (requestWfhForm.errors.isHalfDay &&
                                      requestWfhForm.touched.isHalfDay
                                        ? " is-invalid"
                                        : "")
                                    }
                                    checked={checkedHalfDay}
                                    onChange={(e) =>
                                      setCheckedHalfDay(e.target.checked)
                                    }
                                    value={requestWfhForm.values.isHalfDay}
                                    style={{ borderColor: "#a49a9a" }}
                                  />
                                  <label
                                    className="form-check-label text-primary mb-3 sumh04"
                                    htmlFor="customCheckBox3"
                                  >
                                    Half Day ?
                                  </label>
                                </div>
                                {checkedHalfDay && (
                                  <div className="basic-form mx-3">
                                    <label className="switch2 ">
                                      <input
                                        type="checkbox"
                                        name="halfPreference"
                                        onChange={requestWfhForm.handleChange}
                                        value={
                                          requestWfhForm.values.halfPreference
                                        }
                                        disabled={
                                          checkedHalfDay == false ? true : false
                                        }
                                      />
                                      <span>
                                        <em></em>
                                        <strong></strong>
                                      </span>
                                    </label>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="btns-grp text-right">
                                <button
                                  type="submit"
                                  className="savebtn-click m-0"
                                >
                                  Submit Request
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4">
                    <div className="side-add-section pl-0">
                      <div className="card right-div">
                        <div className="card-body">
                          <div className="text-center">
                            <h4 className="how-it mb-4">How it work ?</h4>
                            <img
                              src="images/org-img/leave/apply_for_others.svg"
                              style={{ width: "70%" }}
                            />

                            <ul className="ul-work text-dark text-left mt-4">
                              <li>
                                <i className="fa fa-check-square-o"></i>
                                {howItWorksText}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}
export default WFHForOther;
